import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const horizontalStatusPageNavEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-horizontal-status-page-nav" */ './src/ui/HorizontalStatusPageNav'
			).then((module) => module.HorizontalStatusPageNav),
		{ includeInShellOnlySsrBundle: true },
	),
	getPreloadProps: () => ({}),
});
